import React from 'react';
import TariffType from './tariffTypeLanding';

const tariffTypesLanding = (props) => {
    return props.tariffTypes.map(tt => {
        return (<TariffType tt={tt} selectTariffModel={(tm) => props.selectTariffModel(tm)}
                            selectedMunicipality={props.selectedMunicipality}
                            tariffModelShortNames={props.tariffModelShortNames}/>)
    })
};

export default tariffTypesLanding;
